import { request } from '@/utils/request';

export const createReport = async data => (await request.post('/reports/', data)).data;
export const fetchMyReports = async (params = {}) => (await request.get('/reports/', { params })).data;
export const fetchMyReport = async id => (await request.get(`/reports/${id}/`)).data;
export const fetchAdminReports = async (params = {}) => (await request.get('/user/admin/reports/', { params })).data;
export const fetchAdminReport = async id => (await request.get(`/user/admin/reports/${id}/`)).data;
export const reviewReport = async (id, data) => (await request.patch(`/user/admin/reports/${id}/`, data)).data;
